import * as config from './../config/config'
import api from "./interceptor"


export async function loginUsers(email, password){
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_AUTHENTIFICATION,{
        "email": email,
        "password": password
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function get_all_users(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_USER);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function create_users(data){
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_USER, {
      "email": data['email'],
      "nom": data['nom'],
      "prenom": data['prenom'],
      "password": data['prenom'],
      "mobile": data['mobile'],
      "fonction_id": data['fonction_id'],
      "agence_id": data['agence_id']
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function update_users(data){
  try {
    console.log(data);
    const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_USER + '/'+ data['id'], {
      "email": data['email'],
      "nom": data['nom'],
      "prenom": data['prenom'],
      "password": data['password'],
      "password_confirm": data['password_confirm'],
      "mobile": data['mobile'],
      "fonction_id": data['fonction_id'],
      "agence_id": data['agence_id']
    });
    console.log(response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function delete_users(data){
  try {
    const response = await api.delete(config.REACT_APP_ENDPOINT_DELETE_USER + '/' + data['id']);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function create_permission(data) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_CREATE_PERMISSION,
      {
        nom: data.nom,
        description: data.description,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function get_all_permissions() {
  try {
    const response = await api.get(
      config.REACT_APP_ENDPOINT_LIST_PERMISSION
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}


export async function get_user_permissions(userId) {
  try {
    const response = await api.get(
      `${config.REACT_APP_ENDPOINT_USER_PERMISSIONS}/${userId}/permissions`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function update_user_permissions(data) {
  try {
    const response = await api.put(
      config.REACT_APP_ENDPOINT_UPDATE_USER_PERMISSIONS,
      {
        user_id: data.user_id,
        permissions: data.permissions, // tableau d'IDs
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

// api/users.js

export async function get_all_agences() {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LISTE_AGENCE);
    return response.data;
  } catch (error) {
    throw error;
  }
}
